import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { VatCodeVatValuesTable } from "./VatCodeVatValuesTable";

export const VatCodeVatValuesTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <VatCodeVatValuesTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
